module.exports = __webpack_public_path__ + "img/05.9f7d2d1e.png";